<script setup lang="ts">
import { SellingMethod } from '~/apiClient';

// COMPOSABLES
const sellingMethod = useSlpSellingMethod();
const {
    brandId,
    modelId,
    suspenseBrands,
    suspenseModels,
    suspenseVersions,
    suspenseBusAssetsAttributeValues,
    suspenseAuctionStates,
    page,
    itemsPerPage,
} = useSlpParams(sellingMethod);
const { trackViewSaleList, syncTrackingGlobalSales } = useTracking();

// DATA
const { suspense, sales, totalItems, isPending, error, refetch } = useSlpData();
const slpSuspense = useSlpSuspenseState();

if (import.meta.server) {
    await suspenseBusAssetsAttributeValues();
    sellingMethod.value === SellingMethod.Auction && (await suspenseAuctionStates());
    await suspenseBrands();
    brandId.value && (await suspenseModels());
    modelId.value && (await suspenseVersions());
}

(slpSuspense.value || import.meta.server) && (await suspense());

syncTrackingGlobalSales(sales);

// SEO
useSlpSeoMeta({ totalItems: toRef(() => totalItems.value.current) });

// WATCHERS
useSlpWatchers({ error, refetch });

watch(
    sales,
    () => {
        if (!import.meta.server && !isPending.value) trackViewSaleList(sales.value);
    },
    { immediate: true }
);
</script>

<template>
    <div>
        <SlpHero />
        <SlpList :sales="sales" :pagination="{ page, itemsPerPage, total: totalItems.current }" :is-loading="isPending" />
        <MktgWhyFleequid class="border-b border-white/15" />
    </div>
</template>
